export default "__VITE_ASSET__B3uvvS8r__"